import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Link, IconButton } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';

const ActionColumn = ({
  effort,
  normalizedEffort,
  isExternal = false,
  onRemoveExternalEffort,
  onEditExternalEffort,
  company,
  showActions = true,
}) => {
  // Always render the container to maintain consistent spacing
  return (
    <Box sx={{ flex: 1.5, minWidth: 0, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1, mr: 2 }}>
      {/* Query Profile Button - Only for regular queries */}
      {!isExternal && showActions && (
        <Button
          component={Link}
          href={normalizedEffort.profileLink}
          target="_blank"
          variant="outlined"
          sx={{
            textTransform: 'none',
            minWidth: 'auto',
            flexShrink: 0,
          }}
        >
          Query
        </Button>
      )}

      {/* Article Button - Common for both types */}
      {normalizedEffort.link && (
        <Button
          component={Link}
          href={normalizedEffort.link}
          target="_blank"
          variant="contained"
          sx={{
            textTransform: 'none',
            minWidth: 'auto',
            flexShrink: 0,
            mr: isExternal && (onEditExternalEffort || onRemoveExternalEffort) && showActions ? 1 : 0,
          }}
        >
          Article
        </Button>
      )}

      {/* External Effort Management Actions */}
      {isExternal && showActions && (
        <>
          {onEditExternalEffort && (
            <IconButton size="small" color="primary" onClick={() => onEditExternalEffort(company, effort)} title="Edit additional effort">
              <Edit fontSize="small" />
            </IconButton>
          )}
          {onRemoveExternalEffort && (
            <IconButton size="small" color="error" onClick={() => onRemoveExternalEffort(effort.id)} title="Remove additional effort">
              <Delete fontSize="small" />
            </IconButton>
          )}
        </>
      )}
    </Box>
  );
};

ActionColumn.propTypes = {
  effort: PropTypes.object.isRequired,
  normalizedEffort: PropTypes.object.isRequired,
  isExternal: PropTypes.bool,
  onRemoveExternalEffort: PropTypes.func,
  onEditExternalEffort: PropTypes.func,
  company: PropTypes.string,
  showActions: PropTypes.bool,
};

export default ActionColumn;
